import React, { useMemo, useRef, useState } from "react"
import ReportColumnSelector from "components/Common/ReportColumnSelector"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector, useDispatch } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"
import { getMonitorItems } from "store/monitor-dashboard/monitor-dashboard-action"
import { monitorConsumptionAction } from "store/monitor-consumption/monitor-consumption-slice"
import {
  getMonitorConsumptionsFacilities,
  getMonitorConsumptionsIPs,
  getMonitorConsumptionsProjects,
  getMonitorConsumptionsProvince,
} from "store/monitor-consumption/monitor-consumption-action"

const MonitorConsumptionReporFilter2 = ({
  onAdvancedSearchSubmit,
  loading,
  error,
  columns = [],
  onToggleColumn = () => {},
  onReorder = () => {},
}) => {
  const dateFlatpickerfrom = useRef(null)
  const dateFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batch_number, setBatchNumber] = useState("")
  const [province, setProvince] = useState(null)
  const [facility, setFacility] = useState(null)
  const [ip, setIP] = useState(null)
  const [provinceIp, setProvinceIp] = useState(null)
  const [project, setProject] = useState(null)
  const [qtr, setQtr] = useState([])

  const dispatch = useDispatch()

  const [date, setDate] = useState({
    from: null,
    to: null,
  })

  const categories = useSelector(
    state => state.monitorDashboard.MonitorItemCategoires
  )
  const ips = useSelector(state => state.monitorDashboard.MonitorIps)
  const Provinceips = useSelector(
    state => state.monitorConsumptions.monitorConsumpIPs
  )

  const items = useSelector(state => state.monitorDashboard.MonitorItems)

  const projects = useSelector(
    state => state.monitorConsumptions.monitorConsumpProjects
  )
  const provinces = useSelector(
    state => state.monitorConsumptions.monitorConsumpProvinces
  )

  const facilities = useSelector(
    state => state.monitorConsumptions.monitorConsumpFacilities
  )

  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const handleSubmit = () => {
    let data = {}

    data.date = {
      from: date.from ? date.from : null,
      to: date.to ? date.to : null,
    }
    if (item) {
      data.item = item.map(ite => (ite.value ? ite.value : ite))
    }
    data.category = isObject(category) ? category.value : null
    data.providerIP = isObject(ip) ? ip.value : null
    data.ip_id = isObject(provinceIp) ? provinceIp.value : null
    data.province = isObject(province) ? province.value : null
    if (facility) {
      data.facility = facility.map(ite => (ite.value ? ite.value : ite))
    }
    data.project_id = isObject(project) ? project.value : null
    data.batch_number = batch_number
    if (qtr) {
      data.qtr = qtr.map(qt => (qt.value ? qt.value : qt))
    }
    onAdvancedSearchSubmit(data)
  }

  const onClearHandler = () => {
    dateFlatpickerfrom.current.flatpickr.clear()
    dateFlatpickerto.current.flatpickr.clear()
    setItem(null)
    setCategory(null)
    setBatchNumber("")
    setDate({ from: null, to: null })
    setProvince(null)
    setFacility(null)
    setIP(null)
    setProject("")
    setProvinceIp("")
    setQtr([])
    dispatch(monitorConsumptionAction.resetState())
    onAdvancedSearchSubmit({})
  }

  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getMonitorItems(cate.value))
  }

  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }

  const onQtrChangeHandler = value => {
    const check = value.some(val => val.value === "all")
    if (check) {
      setQtr(QUARTERS)
    } else {
      setQtr(value)
    }
  }

  const onIPChangeHandler = ips => {
    setIP(ips)
    dispatch(getMonitorConsumptionsProjects({ ip_id: ips.value }))
  }

  const onProjectChangeHandler = proj => {
    dispatch(
      getMonitorConsumptionsIPs({ project_id: proj.value, ip_id: ip.value })
    )
    setProject(proj)
  }

  const onProvinceIPChangeHandler = ips => {
    setProvinceIp(ips)
    dispatch(
      getMonitorConsumptionsProvince({
        providerIP: ip.value,
        project_id: project.value,
        ip_id: ips.value,
      })
    )
  }
  const onProvinceChangeHandler = prov => {
    setProvince(prov)
    dispatch(
      getMonitorConsumptionsFacilities({
        project_id: project.value,
        ip_id: provinceIp.value,
        province_id: prov.value,
      })
    )
  }

  const onFacilityChangeHandler = value => {
    const check = value.some(ite => ite.value === "all")
    if (check) {
      setFacility(facilities?.data)
    } else {
      setFacility(value)
    }
  }

  const onBatchNumberChange = batch_number => {
    setBatchNumber(batch_number.target.value)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Providers</Label>
            {ips?.data && (
              <Select
                options={ips?.data}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
            {error?.errors?.ip_id?.[0] && (
              <p className="text-danger">{error?.errors?.ip_id?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                options={projects?.data}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
            {error?.errors?.project?.[0] && (
              <p className="text-danger">{error?.errors?.project?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Province IPs</Label>
            {Provinceips?.data && (
              <Select
                options={Provinceips?.data}
                value={provinceIp}
                onChange={onProvinceIPChangeHandler}
              />
            )}
            {error?.errors?.ip_id?.[0] && (
              <p className="text-danger">{error?.errors?.ip_id?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Provinces</Label>
            {provinces?.data && (
              <Select
                options={provinces?.data}
                value={province}
                onChange={onProvinceChangeHandler}
              />
            )}
            {error?.errors?.province?.[0] && (
              <p className="text-danger">{error?.errors?.province?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Facility</Label>
            {facilities?.data && (
              <Select
                options={[{ value: "all", label: "All" }, ...facilities?.data]}
                value={facility}
                isMulti={true}
                onChange={onFacilityChangeHandler}
              />
            )}
            {error?.errors?.facility?.[0] && (
              <p className="text-danger">{error?.errors?.facility?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category}
                onChange={onCategoryChangeHandler}
              />
            )}
            {error?.errors?.category?.[0] && (
              <p className="text-danger">{error?.errors?.category?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                isMulti={true}
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
            {error?.errors?.item?.[0] && (
              <p className="text-danger">{error?.errors?.item?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Batch Number</Label>
            <Input
              name="batch_number"
              placeholder="Batch Number"
              type="text"
              onChange={onBatchNumberChange}
              value={batch_number}
            />
          </Col>
          {/* <Col>
            <Label className="form-label">Quarter</Label>
            <Select
              isMulti={true}
              options={[{ value: "all", label: "All" }, ...QUARTERS]}
              value={qtr}
              onChange={onQtrChangeHandler}
            />
          </Col> */}
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">From Date</Label>
            <Flatpickr
              ref={dateFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">To Date</Label>
            <Flatpickr
              ref={dateFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>
      <ReportColumnSelector columns={columns} onToggle={onToggleColumn} onReorder={onReorder} />


      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default MonitorConsumptionReporFilter2
